(() => {
  const initialize = () => {
    const configElement = document.getElementById('ConsumerAnalyticsConfig');
    const controls = document.querySelector('[data-consumer-analytics]');
    if (!configElement || !controls || controls.dataset.analyticsReady === 'true') return;
    let config;
    try { config = JSON.parse(configElement.textContent); } catch { return; }

    const measurementId = config.measurementId;
    const excludedPaths = /^\/(?:account(?:\/|$)|accounts(?:\/|$)|apps(?:\/|$)|customer_authentication(?:\/|$)|password(?:\/|$)|checkouts?(?:\/|$))/i;
    const excludedPages = /^\/pages\/(?:business|innovative-spas|evergreen-softub-sauna|pettis-pools|wholesale|dealer[^/]*|[^/]*warranty[^/]*)(?:\/|$)/i;
    const consumerContext = () => {
      const url = new URL(window.location.href);
      const view = (url.searchParams.get('view') || '').toLowerCase();
      return config.audience === 'consumer' && config.b2bCustomer !== true &&
        ['serenovaspas.com', 'www.serenovaspas.com'].includes(url.hostname.toLowerCase()) &&
        !window.Shopify?.designMode && !document.body.classList.contains('dealer-workspace') &&
        !excludedPaths.test(url.pathname) && !excludedPages.test(url.pathname) &&
        !['bulk', 'dealer'].includes(view);
    };
    if (!/^G-[A-Z0-9]{4,20}$/.test(measurementId || '') || !consumerContext()) {
      controls.remove();
      return;
    }
    controls.dataset.analyticsReady = 'true';

    const banner = controls.querySelector('[data-analytics-banner]');
    const dialog = controls.querySelector('dialog');
    const preferencesButton = controls.querySelector('[data-analytics-preferences]');
    const choiceButtons = Array.from(controls.querySelectorAll('[data-analytics-choice]'));
    const bannerStatus = controls.querySelector('[data-analytics-banner-status]');
    const dialogStatus = controls.querySelector('[data-analytics-dialog-status]');
    const dismissButton = controls.querySelector('[data-analytics-dismiss]');
    const legalLinks = document.querySelector('.consumer-footer .footer__legal-links, .consumer-footer__legal ul');
    if (legalLinks) {
      const item = document.createElement('li');
      item.append(preferencesButton);
      legalLinks.append(item);
      controls.querySelector('[data-analytics-preferences-container]')?.remove();
    }

    const privacy = () => {
      const api = window.Shopify?.customerPrivacy;
      return typeof api?.currentVisitorConsent === 'function' &&
        typeof api?.analyticsProcessingAllowed === 'function' &&
        typeof api?.setTrackingConsent === 'function' ? api : null;
    };
    const denialStorageKey = 'serenova-analytics-denied';
    let storedDenied = false;
    try { storedDenied = window.localStorage.getItem(denialStorageKey) === '1'; } catch { /* Native consent still applies when preference storage is unavailable. */ }
    let localDenied = storedDenied;
    const currentChoice = () => {
      try { return privacy()?.currentVisitorConsent()?.analytics || ''; } catch { return ''; }
    };
    const nativeAllowed = () => {
      try {
        return !localDenied && consumerContext() && currentChoice() === 'yes' && privacy()?.analyticsProcessingAllowed() === true;
      } catch { return false; }
    };
    const allowed = () => !busy && !preferenceSaveFailed && nativeAllowed();
    const safeLocation = () => {
      const url = new URL(window.location.href);
      return `${url.origin}${url.pathname}`;
    };
    const safeReferrer = () => {
      try {
        const url = new URL(document.referrer);
        return ['https:', 'http:'].includes(url.protocol) ? `${url.origin}/` : '';
      } catch { return ''; }
    };
    const titles = new Set(['Home', 'Product', 'Collection', 'Search', 'Cart', 'Policy', 'Blog', 'Article', 'Contact', 'Financing', 'Buying guide', 'Consumer page', 'Consumer storefront']);
    const pageTitle = titles.has(config.pageTitle) ? config.pageTitle : 'Consumer storefront';
    // Campaigns use fixed vocabulary rather than forwarding arbitrary URL values.
    // Keep URLs, click IDs, search terms, content labels and customer data out.
    const campaignSources = new Map([
      ['google', 'google'], ['bing', 'bing'], ['facebook', 'facebook'], ['fb', 'facebook'],
      ['instagram', 'instagram'], ['ig', 'instagram'], ['pinterest', 'pinterest'],
      ['youtube', 'youtube'], ['tiktok', 'tiktok'], ['newsletter', 'newsletter'],
      ['email', 'email'], ['serenova', 'serenova'], ['serenovaspas', 'serenova']
    ]);
    const campaignMedia = new Map([
      ['cpc', 'cpc'], ['ppc', 'cpc'], ['paid_search', 'paid_search'], ['paid_social', 'paid_social'],
      ['social', 'social'], ['email', 'email'], ['organic', 'organic'], ['referral', 'referral'],
      ['display', 'display'], ['sms', 'sms'], ['qr', 'qr'], ['print', 'print']
    ]);
    const campaignWords = new Set(('serenova spa spas softub consumer launch brand spring summer fall autumn winter holiday sale promo promotion newsletter ' +
      'january february march april may june july august september october november december memorial labor day black friday cyber monday').split(' '));
    const campaignParameters = () => {
      if (!allowed()) return {};
      const params = new URL(window.location.href).searchParams;
      const singleValue = (name) => params.getAll(name).length === 1 ? params.get(name).toLowerCase() : '';
      const source = campaignSources.get(singleValue('utm_source'));
      const medium = campaignMedia.get(singleValue('utm_medium'));
      if (!source || !medium) return {};
      const campaign = singleValue('utm_campaign');
      const result = { campaign_source: source, campaign_medium: medium };
      if (campaign.length >= 2 && campaign.length <= 64 && /^[a-z0-9]+(?:[-_][a-z0-9]+)*$/.test(campaign) &&
        campaign.split(/[-_]/).every((word) => campaignWords.has(word) || /^20\d{2}$/.test(word))) {
        result.campaign_name = campaign;
      }
      return result;
    };
    const adConsent = { ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' };
    const disableKey = `ga-disable-${measurementId}`;
    const propertyCookie = `_ga_${measurementId.slice(2).replace(/-/g, '_')}`;
    let configured = false;
    let active = false;
    let activeSince = Infinity;
    let busy = false;
    let savingAllowance = false;
    let preferenceSaveFailed = false;
    let saveFromBanner = false;
    let bannerDismissed = false;
    let returnFocus = null;
    const cancelPendingLeads = new Set();
    const cancelPendingGuides = new Set();
    const commerceContextKey = 'serenova-consumer-measurement-v1';
    const commerceRevocationKey = 'serenova-consumer-commerce-revocation-v1';
    const cartRemovalKey = 'serenova-consumer-cart-removal-v1';
    const cartRemovalEvent = 'serenova_consumer_cart_changed';
    const numericCommerceId = (value) => typeof value === 'string' && /^[1-9]\d{0,23}$/.test(value);
    const commerceUuid = (value) => typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
    const exactFields = (value, required, optional = []) => value && typeof value === 'object' && !Array.isArray(value) &&
      required.every((field) => Object.hasOwn(value, field)) && Object.keys(value).every((field) => required.includes(field) || optional.includes(field));
    const commerceCurrencies = new Set(typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('currency') : []);
    const cartSnapshot = () => {
      const source = config.cart;
      if (!/^\/cart\/?$/.test(window.location.pathname) || !exactFields(source, ['currency', 'items']) ||
        !commerceCurrencies.has(source.currency) || !Array.isArray(source.items) || source.items.length > 50) return null;
      const seen = new Set();
      const items = [];
      for (const item of source.items) {
        if (!exactFields(item, ['productId', 'variantId', 'quantity', 'finalPrice', 'finalLinePrice']) ||
          !numericCommerceId(item.productId) || !numericCommerceId(item.variantId) ||
          !Number.isSafeInteger(item.quantity) || item.quantity < 1 || item.quantity > 999) return null;
        const identity = `${item.productId}:${item.variantId}`;
        // Properties and discounts can split one variant into several lines.
        // Without retaining private line keys those changes are ambiguous.
        if (seen.has(identity)) return null;
        seen.add(identity);
        const result = { productId: item.productId, variantId: item.variantId, quantity: item.quantity };
        const unit = 10 ** -new Intl.NumberFormat('en', { style: 'currency', currency: source.currency }).resolvedOptions().maximumFractionDigits;
        if (Number.isSafeInteger(item.finalPrice) && item.finalPrice >= 0 && item.finalPrice <= 1e11 &&
          Number.isSafeInteger(item.finalLinePrice) && item.finalLinePrice === item.finalPrice * item.quantity &&
          Math.abs(item.finalPrice / 100 / unit - Math.round(item.finalPrice / 100 / unit)) < 0.0001) result.unitPrice = item.finalPrice / 100;
        items.push(result);
      }
      return { currency: source.currency, items };
    };
    let liveCommerceContext = null;
    let pendingCartRemoval = null;
    let cartSnapshotFresh = true;
    let cartRemovalChecked = false;
    // Consume once before confirmation. Never keep a passive history of carts.
    // Parsing waits for a fresh, explicitly permitted commerce context below.
    try {
      if (config.commercePixel === true) {
        const raw = window.sessionStorage.getItem(cartRemovalKey);
        window.sessionStorage.removeItem(cartRemovalKey);
        if (typeof raw === 'string' && raw.length <= 16000) pendingCartRemoval = raw;
      }
    } catch { pendingCartRemoval = null; }
    const discardCartRemoval = () => {
      pendingCartRemoval = null;
      if (config.commercePixel !== true) return;
      try { window.sessionStorage.removeItem(cartRemovalKey); } catch { /* Optional measurement fails closed. */ }
    };
    const confirmCartRemoval = (context) => {
      if (cartRemovalChecked || !pendingCartRemoval || !active || !allowed() || !consumerContext()) return;
      cartRemovalChecked = true;
      const raw = pendingCartRemoval;
      pendingCartRemoval = null;
      try {
        const previous = JSON.parse(raw);
        const now = Date.now();
        const snapshot = cartSnapshotFresh ? cartSnapshot() : null;
        if (!snapshot || !exactFields(previous, ['v', 'id', 'at', 'expiresAt', 'clientId', 'sessionId', 'consentedAt', 'sourcePageId', 'sourceIssuedAt', 'sourceExpiresAt', 'currency', 'items']) ||
          previous.v !== 1 || !commerceUuid(previous.id) || !commerceUuid(previous.sourcePageId) || previous.sourcePageId === context.pageId ||
          previous.clientId !== context.clientId || previous.sessionId !== context.sessionId || previous.consentedAt !== context.consentedAt ||
          previous.currency !== snapshot.currency || ![previous.at, previous.expiresAt, previous.sourceIssuedAt, previous.sourceExpiresAt].every(Number.isSafeInteger) ||
          previous.at < previous.consentedAt || previous.at < previous.sourceIssuedAt || previous.at > context.pageStartedAt ||
          previous.at >= previous.sourceExpiresAt || previous.sourceExpiresAt > previous.sourceIssuedAt + 30 * 60 * 1000 ||
          previous.expiresAt <= now || previous.expiresAt <= previous.at || previous.expiresAt > previous.at + 60000 ||
          !Array.isArray(previous.items) || !previous.items.length || previous.items.length > 50) return;
        const actual = new Map(snapshot.items.map((item) => [`${item.productId}:${item.variantId}`, item]));
        const identities = new Set();
        const added = [];
        const removed = [];
        for (const item of previous.items) {
          if (!exactFields(item, ['productId', 'variantId', 'quantity', 'intendedQuantity'], ['unitPrice']) ||
            !numericCommerceId(item.productId) || !numericCommerceId(item.variantId) ||
            !Number.isSafeInteger(item.quantity) || item.quantity < 1 || item.quantity > 999 ||
            !Number.isSafeInteger(item.intendedQuantity) || item.intendedQuantity < 0 || item.intendedQuantity > 999 ||
            (Object.hasOwn(item, 'unitPrice') && (typeof item.unitPrice !== 'number' || !Number.isFinite(item.unitPrice) || item.unitPrice < 0 || item.unitPrice > 1e9))) return;
          const identity = `${item.productId}:${item.variantId}`;
          const currentItem = actual.get(identity);
          if (identities.has(identity) || (currentItem?.quantity || 0) !== item.intendedQuantity) return;
          identities.add(identity);
          actual.delete(identity);
          if (item.quantity > item.intendedQuantity) removed.push({ productId: item.productId, variantId: item.variantId,
            quantity: item.quantity - item.intendedQuantity, ...(Object.hasOwn(item, 'unitPrice') ? { unitPrice: item.unitPrice } : {}) });
          if (item.quantity < item.intendedQuantity) added.push({ productId: item.productId, variantId: item.variantId,
            quantity: item.intendedQuantity - item.quantity, ...(Object.hasOwn(currentItem, 'unitPrice') ? { unitPrice: currentItem.unitPrice } : {}) });
        }
        if (actual.size || (!added.length && !removed.length) || !active || !allowed() || liveCommerceContext !== context) return;
        // A fresh server-rendered cart exactly confirms the requested mutation.
        // This custom event owns /cart change tracking; native events there
        // are ignored by the pixel to avoid measuring the same action twice.
        window.Shopify?.analytics?.publish?.(cartRemovalEvent, {
          v: 1, mutationId: previous.id, attemptedAt: previous.at, sourcePageId: previous.sourcePageId, pageId: context.pageId,
          clientId: context.clientId, sessionId: context.sessionId, consentedAt: context.consentedAt,
          currency: snapshot.currency, added, removed
        })?.catch?.(() => {});
      } catch { /* Missing, stale, or unverifiable proof is never measured. */ }
    };
    const rememberCartRemoval = (intended) => {
      discardCartRemoval();
      try {
        const context = liveCommerceContext;
        const snapshot = cartSnapshotFresh ? cartSnapshot() : null;
        const now = Date.now();
        if (!snapshot || !context || !active || !allowed() || !consumerContext() ||
          context.page !== safeLocation() || context.expiresAt <= now || context.consentedAt > now ||
          !Array.isArray(intended) || intended.length !== snapshot.items.length ||
          intended.some((value) => !Number.isSafeInteger(value) || value < 0 || value > 999) ||
          !snapshot.items.some((item, index) => item.quantity !== intended[index])) return;
        const id = window.crypto?.randomUUID?.();
        if (!commerceUuid(id)) return;
        window.sessionStorage.setItem(cartRemovalKey, JSON.stringify({
          v: 1, id, at: now, expiresAt: Math.min(now + 60000, context.expiresAt),
          clientId: context.clientId, sessionId: context.sessionId, consentedAt: context.consentedAt,
          sourcePageId: context.pageId, sourceIssuedAt: context.issuedAt, sourceExpiresAt: context.expiresAt,
          currency: snapshot.currency, items: snapshot.items.map((item, index) => ({ ...item, intendedQuantity: intended[index] }))
        }));
      } catch { discardCartRemoval(); }
    };
    const commercePageId = (() => {
      if (config.commercePixel !== true) return '';
      try { return window.crypto?.randomUUID?.() || ''; } catch { return ''; }
    })();
    const commercePageStartedAt = Math.floor(Number.isFinite(performance.timeOrigin) ? performance.timeOrigin : Date.now());
    let commerceGeneration = 0;
    let commerceRefresh = null;
    let commerceConsentStartedAt = 0;
    let commerceConsentBoundary = 0;
    let startupCommerceContext = null;
    let startupCommerceExpiry = null;
    const discardStartupContext = () => {
      startupCommerceContext = null;
      clearTimeout(startupCommerceExpiry);
      startupCommerceExpiry = null;
    };
    // Keep only evidence of a previous permitted interval while the native
    // privacy library loads. Shared checkout access is still cleared below.
    // Fresh native permission and matching Google IDs must verify it before use.
    if (config.commercePixel === true && !localDenied && !privacy()) {
      try {
        const raw = window.sessionStorage.getItem(commerceContextKey);
        const prior = typeof raw === 'string' && raw.length <= 2048 ? JSON.parse(raw) : null;
        const now = Date.now();
        const page = prior && typeof prior.page === 'string' ? new URL(prior.page) : null;
        const path = page ? decodeURIComponent(page.pathname) : '';
        if (prior?.v === 1 && prior.audience === 'consumer' && prior.measurementId === measurementId &&
          typeof prior.clientId === 'string' && /^\d{1,20}\.\d{1,20}$/.test(prior.clientId) &&
          typeof prior.sessionId === 'string' && /^[1-9]\d{0,15}$/.test(prior.sessionId) && Number.isSafeInteger(Number(prior.sessionId)) &&
          /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(prior.pageId || '') &&
          [prior.consentedAt, prior.issuedAt, prior.expiresAt, prior.pageStartedAt].every(Number.isSafeInteger) &&
          prior.consentedAt > 0 && prior.consentedAt <= prior.issuedAt && prior.issuedAt <= now &&
          prior.pageStartedAt > 0 && prior.pageStartedAt <= prior.issuedAt &&
          prior.expiresAt > now && prior.expiresAt <= prior.issuedAt + 30 * 60 * 1000 &&
          page?.protocol === 'https:' && !page.port && !page.username && !page.password &&
          ['serenovaspas.com', 'www.serenovaspas.com'].includes(page.hostname) &&
          prior.page === `${page.origin}${page.pathname}` &&
          !/\\|\/\//.test(path) && !excludedPaths.test(path) && !excludedPages.test(path)) {
          startupCommerceContext = {
            v: 1, audience: 'consumer', measurementId, clientId: prior.clientId, sessionId: prior.sessionId,
            consentedAt: prior.consentedAt, issuedAt: prior.issuedAt, expiresAt: prior.expiresAt
          };
          startupCommerceExpiry = setTimeout(() => { discardStartupContext(); sync(); }, prior.expiresAt - now + 1);
        }
      } catch { /* Unknown prior state cannot preserve an interval. */ }
    }
    window[disableKey] = true;

    const deleteAnalyticsCookies = () => {
      const domains = ['', window.location.hostname, `.${window.location.hostname}`, 'serenovaspas.com', '.serenovaspas.com'];
      for (const name of ['_ga', propertyCookie]) {
        for (const domain of new Set(domains)) {
          try {
            document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax${domain ? `; Domain=${domain}` : ''}`;
          } catch { /* Cookie restrictions must not interrupt privacy controls. */ }
        }
      }
    };
    const tag = (...args) => window.gtag(...args);
    const publishCommerceContext = (context) => {
      if (config.commercePixel !== true) return false;
      try {
        if (typeof window.Shopify?.analytics?.publish !== 'function') return false;
        const result = window.Shopify.analytics.publish('serenova_consumer_measurement', { context });
        result?.catch?.(() => {});
        return true;
      } catch { return false; }
    };
    const clearCommerceContext = (waitingForPrivacy = false) => {
      commerceGeneration += 1;
      clearTimeout(commerceRefresh);
      commerceRefresh = null;
      commerceConsentStartedAt = 0;
      liveCommerceContext = null;
      if (!waitingForPrivacy) discardStartupContext();
      if (config.commercePixel !== true) return false;
      try { window.sessionStorage.removeItem(commerceContextKey); } catch {
        waitingForPrivacy = false;
        discardStartupContext();
      }
      if (!waitingForPrivacy) {
        discardCartRemoval();
        commerceConsentBoundary = Math.max(commerceConsentBoundary, Date.now());
        publishCommerceContext(null);
      }
      return waitingForPrivacy;
    };
    const refreshCommerceContext = () => {
      if (config.commercePixel !== true || !commercePageId || !active || !configured) return;
      const retryWhileSaving = (callback) => {
        if (busy && savingAllowance && active && nativeAllowed()) {
          clearTimeout(commerceRefresh);
          commerceRefresh = setTimeout(callback, 1000);
        }
      };
      if (!allowed()) { retryWhileSaving(refreshCommerceContext); return; }
      const generation = commerceGeneration;
      let previousContext = null;
      try { previousContext = JSON.parse(window.sessionStorage.getItem(commerceContextKey)); } catch { /* A fresh grant does not need prior context. */ }
      if (!previousContext) previousContext = startupCommerceContext;
      let clientId = '';
      let sessionId = '';
      let finished = false;
      const finish = () => {
        if (finished || generation !== commerceGeneration || !active) return;
        if (!allowed()) { retryWhileSaving(finish); return; }
        if (!/^\d{1,20}\.\d{1,20}$/.test(clientId) || !/^\d{1,20}$/.test(sessionId)) return;
        finished = true;
        const issuedAt = Date.now();
        let priorConsentBoundary = Infinity;
        try {
          const raw = window.sessionStorage.getItem(commerceRevocationKey);
          if (raw === null) priorConsentBoundary = 0;
          else if (raw.length <= 256) {
            const revocation = JSON.parse(raw);
            if (revocation && typeof revocation === 'object' && !Array.isArray(revocation) &&
              Object.keys(revocation).length === 3 && revocation.v === 1 &&
              Number.isSafeInteger(revocation.at) && revocation.at > 0 && revocation.at <= issuedAt &&
              Number.isSafeInteger(revocation.expiresAt) && revocation.expiresAt > revocation.at &&
              revocation.expiresAt <= revocation.at + 30 * 60 * 1000) {
              priorConsentBoundary = revocation.expiresAt > issuedAt ? revocation.at : 0;
            }
          }
        } catch { /* An unverifiable interval cannot carry prior consent forward. */ }
        priorConsentBoundary = Math.max(priorConsentBoundary, commerceConsentBoundary);
        if (commerceConsentStartedAt < priorConsentBoundary) commerceConsentStartedAt = issuedAt;
        // Preserve the start of an already-permitted session across navigation.
        // Native events created early on this document can then be processed
        // after the getters return, while the pixel still rejects older pages.
        if (previousContext?.v === 1 && previousContext.audience === 'consumer' &&
          previousContext.measurementId === measurementId && previousContext.clientId === clientId && previousContext.sessionId === sessionId &&
          Number.isSafeInteger(previousContext.consentedAt) && previousContext.consentedAt > 0 &&
          previousContext.consentedAt >= priorConsentBoundary &&
          Number.isSafeInteger(previousContext.issuedAt) && previousContext.consentedAt <= previousContext.issuedAt &&
          previousContext.issuedAt <= issuedAt && Number.isSafeInteger(previousContext.expiresAt) &&
          previousContext.expiresAt > issuedAt && previousContext.expiresAt <= previousContext.issuedAt + 30 * 60 * 1000) {
          commerceConsentStartedAt = Math.min(commerceConsentStartedAt, previousContext.consentedAt);
        }
        discardStartupContext();
        const context = {
          v: 1, audience: 'consumer', measurementId, clientId, sessionId,
          consentedAt: commerceConsentStartedAt, issuedAt, expiresAt: issuedAt + 30 * 60 * 1000,
          page: safeLocation(), pageId: commercePageId, pageStartedAt: commercePageStartedAt
        };
        try {
          // Checkout can restore only this short-lived, explicitly permitted
          // context. Storefront pixel events also require a live page publish.
          window.sessionStorage.setItem(commerceContextKey, JSON.stringify(context));
        } catch { return; }
        const published = publishCommerceContext(context);
        liveCommerceContext = context;
        if (published) confirmCartRemoval(context);
        clearTimeout(commerceRefresh);
        commerceRefresh = setTimeout(refreshCommerceContext, published ? 5 * 60 * 1000 : 1000);
      };
      try {
        tag('get', measurementId, 'client_id', (value) => { clientId = typeof value === 'string' ? value : ''; finish(); });
        tag('get', measurementId, 'session_id', (value) => {
          sessionId = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
          finish();
        });
      } catch { /* Optional commerce measurement never affects the storefront. */ }
    };
    const send = (name, params = {}) => {
      if (!active || !allowed() || !configured) return;
      tag('event', name, {
        send_to: measurementId,
        page_location: safeLocation(),
        page_referrer: safeReferrer(),
        page_title: pageTitle,
        ...params
      });
    };
    const activate = () => {
      window[disableKey] = false;
      if (!configured) {
        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
        tag('consent', 'default', { analytics_storage: 'denied', ...adConsent });
        tag('set', 'ads_data_redaction', true);
        tag('set', 'url_passthrough', false);
        tag('consent', 'update', { analytics_storage: 'granted', ...adConsent });
        tag('js', new Date());
        tag('config', measurementId, {
          send_page_view: false,
          allow_google_signals: false,
          allow_ad_personalization_signals: false,
          cookie_expires: 90 * 24 * 60 * 60,
          cookie_update: false,
          cookie_domain: 'none',
          page_location: safeLocation(),
          page_referrer: safeReferrer(),
          page_title: pageTitle,
          ...campaignParameters()
        });
        configured = true;
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
        script.dataset.serenovaAnalytics = '';
        document.head.append(script);
      } else {
        tag('consent', 'update', { analytics_storage: 'granted', ...adConsent });
      }
      active = true;
      activeSince = performance.now();
      commerceConsentStartedAt = Date.now();
      send('page_view');
      const product = config.product;
      if (product && /^\d{1,24}$/.test(product.id || '') && /^[a-z0-9][a-z0-9-]{0,99}$/.test(product.model || '')) {
        send('view_item', { items: [{ item_id: product.id, item_name: product.model }] });
      }
      refreshCommerceContext();
    };
    const deactivate = () => {
      window[disableKey] = true;
      let waitingForPrivacy = !configured && !active && !busy && !preferenceSaveFailed && !localDenied && !privacy() &&
        startupCommerceContext?.expiresAt > Date.now();
      waitingForPrivacy = clearCommerceContext(waitingForPrivacy);
      if (configured && active) {
        tag('consent', 'update', { analytics_storage: 'denied', ...adConsent });
      }
      active = false;
      activeSince = Infinity;
      cancelPendingLeads.forEach((cancel) => cancel());
      cancelPendingGuides.forEach((cancel) => cancel());
      if (!waitingForPrivacy) deleteAnalyticsCookies();
    };
    const sync = () => {
      const choice = currentChoice();
      const permitted = allowed();
      const retainingAllowance = busy && savingAllowance && active && nativeAllowed();
      const keepBannerVisible = saveFromBanner && (busy || preferenceSaveFailed);
      banner.hidden = bannerDismissed || !privacy() || (!keepBannerVisible && (localDenied || choice === 'yes' || choice === 'no'));
      if (dismissButton) dismissButton.hidden = !preferenceSaveFailed || busy;
      dialogStatus.textContent = !privacy() || preferenceSaveFailed ? config.strings.unavailable :
        permitted || retainingAllowance ? config.strings.allowed : localDenied || choice === 'no' ? config.strings.denied : config.strings.unknown;
      choiceButtons.forEach((button) => { button.disabled = busy || !privacy(); });
      if (permitted && !active) activate();
      // Reconfirming an existing allowance should not clear its cookies or
      // start a second page view. A failed save or native revocation still stops it.
      else if (!permitted && !retainingAllowance) {
        deactivate();
      }
    };

    const closeDialog = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      returnFocus?.focus();
    };
    dismissButton?.addEventListener('click', () => {
      if (busy || !preferenceSaveFailed) return;
      localDenied = true;
      try {
        window.localStorage.setItem(denialStorageKey, '1');
        storedDenied = true;
      } catch { /* The current page stays off when storage is unavailable. */ }
      bannerDismissed = true;
      sync();
      preferencesButton.focus({ preventScroll: true });
    });
    preferencesButton.addEventListener('click', () => {
      sync();
      returnFocus = document.activeElement;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      dialog.querySelector('[data-analytics-choice="false"]')?.focus();
    });
    controls.querySelector('[data-analytics-close]').addEventListener('click', closeDialog);
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeDialog(); });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); closeDialog(); }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(dialog.querySelectorAll('a[href], button:not(:disabled)'));
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    choiceButtons.forEach((button) => button.addEventListener('click', () => {
      if (busy || !privacy()) return;
      discardCartRemoval();
      const enabled = button.dataset.analyticsChoice === 'true';
      saveFromBanner = button.closest('[data-analytics-banner]') === banner;
      bannerDismissed = false;
      let preferenceSaved = true;
      preferenceSaveFailed = false;
      if (!enabled) {
        localDenied = true;
        try {
          window.localStorage.setItem(denialStorageKey, '1');
          storedDenied = true;
        } catch { /* A confirmed native refusal does not require this fallback. */ }
        deactivate();
      }
      busy = true;
      savingAllowance = enabled;
      sync();
      bannerStatus.textContent = '';
      let completed = false;
      const finish = (result) => {
        if (completed) return;
        completed = true;
        clearTimeout(saveTimeout);
        if (result && (typeof result !== 'object' || result instanceof Error || 'error' in result)) preferenceSaved = false;
        if (!enabled && currentChoice() !== 'no') preferenceSaved = false;
        if (enabled && preferenceSaved) {
          try {
            if (currentChoice() !== 'yes' || privacy()?.analyticsProcessingAllowed() !== true) {
              preferenceSaved = false;
            } else {
              // Only a persisted refusal needs clearing. Native Shopify consent
              // can save a fresh allowance even when browser storage is blocked.
              if (storedDenied) {
                window.localStorage.removeItem(denialStorageKey);
                storedDenied = false;
              }
              localDenied = false;
            }
          } catch { preferenceSaved = false; }
        }
        busy = false;
        preferenceSaveFailed = !preferenceSaved;
        sync();
        if (!preferenceSaved) {
          bannerStatus.textContent = config.strings.unavailable;
          dialogStatus.textContent = config.strings.unavailable;
          return;
        }
        if (dialog.open) closeDialog();
        else if (banner.hidden) preferencesButton.focus({ preventScroll: true });
      };
      const saveTimeout = setTimeout(() => finish(true), 10000);
      try {
        privacy().setTrackingConsent({ analytics: enabled }, finish);
      } catch {
        finish(true);
      }
    }));

    const watchedGuides = new WeakSet();
    const watchGuides = () => {
      document.querySelectorAll('[data-buying-guide][data-guide-consumer="true"]').forEach((guide) => {
        if (watchedGuides.has(guide)) return;
        watchedGuides.add(guide);
        let cartCompletionHandled = false;
        guide.addEventListener('guide:cart-added', (event) => {
          if (event.target !== guide || cartCompletionHandled) return;
          cartCompletionHandled = true;
          // Once enabled, native Shopify success events own every cart addition,
          // including the guide. Keep this fallback until the pixel is connected.
          if (config.commercePixel === true) return;
          if (!active || !allowed() || !consumerContext()) return;
          const detail = event.detail;
          // An in-flight request begun before consent, or before withdrawal and
          // regrant, must not be replayed as a newly permitted cart addition.
          if (!detail || !Number.isFinite(detail.startedAt) || detail.startedAt < activeSince ||
            detail.startedAt > performance.now() || !Array.isArray(detail.items) ||
            detail.items.length < 1 || detail.items.length > 50) return;
          const ids = new Set();
          const items = [];
          for (const source of detail.items) {
            if (!source || typeof source.item_id !== 'string' || !/^[1-9]\d{0,23}$/.test(source.item_id) ||
              typeof source.item_variant !== 'string' || !/^[1-9]\d{0,23}$/.test(source.item_variant) ||
              ids.has(source.item_variant) || !Number.isSafeInteger(source.quantity) || source.quantity < 1 || source.quantity > 999) return;
            ids.add(source.item_variant);
            const item = { item_id: source.item_id, item_variant: source.item_variant, quantity: source.quantity };
            if (typeof source.price === 'number' && Number.isFinite(source.price) && source.price >= 0 &&
              Number.isSafeInteger(Math.round(source.price * 100))) item.price = source.price;
            items.push(item);
          }
          const params = { items };
          if (typeof detail.currency === 'string' && /^[A-Z]{3}$/.test(detail.currency)) {
            params.currency = detail.currency;
            if (items.every((item) => Number.isFinite(item.price))) {
              const cents = items.reduce((sum, item) => sum + Math.round(item.price * 100) * item.quantity, 0);
              if (Number.isSafeInteger(cents)) params.value = cents / 100;
            }
          }
          send('add_to_cart', params);
        });
        const form = guide.querySelector('[data-guide-form]');
        if (!form) return;
        // Editing an existing result remains the same run. A new page or guide
        // instance starts a new run; denied activity is never replayed on Allow.
        let started = false;
        let completed = false;
        let measuredStart = false;
        const cancelPending = () => { measuredStart = false; };
        cancelPendingGuides.add(cancelPending);
        const start = () => {
          if (started || completed) return;
          started = true;
          measuredStart = allowed();
          if (measuredStart) send('buying_guide_start');
        };
        const choiceStarted = (event) => {
          const input = event.target;
          if (!(input instanceof HTMLInputElement) || input.disabled ||
            !input.matches('input[type="radio"], input[type="checkbox"]')) return;
          const step = input.closest('[data-guide-step]');
          if (step && !step.hidden) start();
        };
        // Capture activation before the guide's radio handler advances the step.
        form.addEventListener('click', choiceStarted, true);
        form.addEventListener('change', choiceStarted, true);
        form.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') choiceStarted(event);
        }, true);
        guide.querySelector('[data-guide-next]')?.addEventListener('click', (event) => {
          if (!event.currentTarget.disabled && !event.currentTarget.hidden) start();
        }, true);
        guide.addEventListener('guide:complete', (event) => {
          if (event.target !== guide || completed) return;
          completed = true;
          if (measuredStart) send('buying_guide_complete');
          measuredStart = false;
        });
      });
    };

    const watchedRoots = new WeakSet();
    const watchedPanels = new WeakSet();
    const watchPanel = (panel) => {
      if (watchedPanels.has(panel)) return;
      watchedPanels.add(panel);
      let attempts = 0;
      const connect = () => {
        if (!panel.isConnected) return;
        const embeds = Array.from(panel.querySelectorAll('shopify-forms-embed'));
        for (const embed of embeds) {
          const root = embed.shadowRoot;
          if (!root || watchedRoots.has(root)) continue;
          watchedRoots.add(root);
          let submitted = false;
          const cancelPending = () => { submitted = false; };
          cancelPendingLeads.add(cancelPending);
          let previouslySuccessful = Boolean(root.querySelector('[data-current-step="success"]'));
          const category = panel.hasAttribute('data-financing-inquiry') ? 'financing' :
            panel.hasAttribute('data-guide-contact-stage') || new URLSearchParams(window.location.search).get('from') === 'buying-guide' ? 'buying_guide' : 'contact';
          root.addEventListener('submit', (event) => {
            if (!(event.target instanceof HTMLFormElement) || previouslySuccessful) return;
            submitted = allowed();
          }, true);
          const observer = new MutationObserver(() => {
            if (!panel.isConnected) { observer.disconnect(); cancelPendingLeads.delete(cancelPending); return; }
            const successful = Boolean(root.querySelector('[data-current-step="success"]'));
            if (successful && !previouslySuccessful) {
              if (submitted) send('generate_lead', { form_category: category });
              submitted = false;
            }
            previouslySuccessful = successful;
          });
          observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-current-step'] });
        }
        if (++attempts < 120 && (!embeds.length || embeds.some((embed) => !embed.shadowRoot))) setTimeout(connect, 250);
      };
      if (panel.hasAttribute('data-guide-contact-stage')) panel.addEventListener('guide:contact', () => {
        attempts = 0;
        connect();
      });
      connect();
    };
    const watchForms = () => {
      document.querySelectorAll('.contact-app-panel--full-width[data-contact-app-panel], [data-guide-contact-stage][data-contact-app-panel], [data-financing-inquiry]').forEach(watchPanel);
    };
    document.addEventListener('shopify:section:load', watchForms);
    document.addEventListener('shopify:section:load', watchGuides);
    // Observe existing native actions without preventing or replacing them.
    // The following server document, never this click/submit, confirms success.
    const modifiedCartActivations = new WeakMap();
    let cartKeyboardActivation = null;
    const clearCartActivationAfterTask = (form, activation) => {
      setTimeout(() => {
        if (modifiedCartActivations.get(form) === activation) modifiedCartActivations.delete(form);
      }, 0);
    };
    const markModifiedCartActivation = (form, key = '') => {
      if (!form?.matches('.cart-page__form')) return;
      discardCartRemoval();
      const activation = {};
      modifiedCartActivations.set(form, activation);
      // SubmitEvent does not retain the originating mouse/keyboard modifiers.
      // Native submission runs in this activation task; do not let a cloned
      // new-tab sessionStorage turn the same intent into two confirmations.
      if (key) cartKeyboardActivation = { form, activation, key };
      else clearCartActivationAfterTask(form, activation);
    };
    const observeCartButtonActivation = (event) => {
      const button = event.target instanceof Element ? event.target.closest('button[name="update"], input[type="submit"][name="update"]') : null;
      if (button && (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)) markModifiedCartActivation(button.form);
    };
    document.addEventListener('click', observeCartButtonActivation, true);
    document.addEventListener('auxclick', observeCartButtonActivation, true);
    document.addEventListener('keydown', (event) => {
      if (!(event.target instanceof Element) || !(event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)) return;
      if (event.key === 'Enter' || (event.key === ' ' && event.target.closest('button[name="update"], input[type="submit"][name="update"]'))) {
        markModifiedCartActivation(event.target.closest('form.cart-page__form'), event.key);
      }
    }, true);
    document.addEventListener('keyup', (event) => {
      if (!cartKeyboardActivation || cartKeyboardActivation.key !== event.key) return;
      const { form, activation } = cartKeyboardActivation;
      cartKeyboardActivation = null;
      // Space activates a focused button on keyup, often in a later task and
      // with a modifier-free click. Retain the guard through that default action.
      clearCartActivationAfterTask(form, activation);
    }, true);
    window.addEventListener('blur', () => {
      if (!cartKeyboardActivation) return;
      const { form, activation } = cartKeyboardActivation;
      cartKeyboardActivation = null;
      if (modifiedCartActivations.get(form) === activation) modifiedCartActivations.delete(form);
    });
    document.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('.cart-page__remove') : null;
      if (!link) return;
      discardCartRemoval();
      if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey ||
        link.hasAttribute('download') || (link.target && link.target !== '_self') || !link.closest('.cart-page__form')) return;
      try {
        const url = new URL(link.href, window.location.origin);
        const snapshot = cartSnapshotFresh ? cartSnapshot() : null;
        const line = url.searchParams.get('line');
        if (!snapshot || url.origin !== window.location.origin || !/^\/cart\/change\/?$/.test(url.pathname) || url.hash ||
          [...url.searchParams.keys()].length !== 2 || url.searchParams.get('quantity') !== '0' ||
          !/^[1-9]\d?$/.test(line || '') || Number(line) > snapshot.items.length) return;
        rememberCartRemoval(snapshot.items.map((item, index) => index === Number(line) - 1 ? 0 : item.quantity));
        queueMicrotask(() => { if (event.defaultPrevented) discardCartRemoval(); });
      } catch { discardCartRemoval(); }
    });
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('.cart-page__form')) return;
      discardCartRemoval();
      if (event.defaultPrevented || modifiedCartActivations.has(form) || event.submitter?.name !== 'update' || form.method.toLowerCase() !== 'post' ||
        (form.target && form.target !== '_self') || ['formtarget', 'formaction', 'formmethod'].some((attribute) => event.submitter.hasAttribute(attribute))) return;
      try {
        const action = new URL(form.action, window.location.origin);
        const snapshot = cartSnapshotFresh ? cartSnapshot() : null;
        const inputs = Array.from(form.querySelectorAll('input[name="updates[]"]'));
        if (!snapshot || action.origin !== window.location.origin || !/^\/cart\/?$/.test(action.pathname) ||
          action.search || action.hash || inputs.length !== snapshot.items.length || inputs.some((input) => input.disabled || !/^\d{1,3}$/.test(input.value))) return;
        rememberCartRemoval(inputs.map((input) => Number(input.value)));
        queueMicrotask(() => { if (event.defaultPrevented) discardCartRemoval(); });
      } catch { discardCartRemoval(); }
    });
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) { cartSnapshotFresh = false; discardCartRemoval(); }
    });
    const measuredCheckoutForms = new WeakSet();
    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('button[name="checkout"]') : null;
      const form = button?.form;
      if (!button || button.disabled || !form?.matches('.cart-page__form') ||
        measuredCheckoutForms.has(form) || !active || !allowed() || !consumerContext()) return;
      const action = new URL(form.action, window.location.origin);
      if (action.origin !== window.location.origin || !/\/cart\/?$/.test(action.pathname)) return;
      measuredCheckoutForms.add(form);
      // This records the consumer's cart-button activation, not checkout entry
      // or a completed order. It never changes the native form submission.
      send('checkout_click');
    });
    document.addEventListener('visitorConsentCollected', () => { discardCartRemoval(); discardStartupContext(); sync(); });
    document.addEventListener('consentTrackingApiLoaded', sync);
    window.addEventListener('pageshow', sync);
    watchForms();
    watchGuides();
    sync();
    if (!privacy() && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) sync();
        else dialogStatus.textContent = config.strings.unavailable;
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
